module.exports = __webpack_public_path__ + "static/media/neutral_sad.d5fc2320.svg";